import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import "reactjs-popup/dist/index.css";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import {
	HeaderImgContainer,
	Nav,
	MobileLocalization,
	Search,
	InputOnly,
	Button,
	ButtonShop,
	ButtonGeo,
	ButtonShopMobile,
	Li,
	Ul,
	HeaderButtonsContainer,
	HeaderImg,
	NavMobile,
	MobileIconContainer,
	MobileHeaderTitleContainer,
	MobileHeaderTitle,
	HeaderContainer,
	HeaderImagePrint,
	CleanSearchImg,
	InputContainer,
	MessageSearch,
    HeaderImgMovilContainer,
    HeaderImgMovil,
} from "./style";
import { StyledMobileMenuICons } from "../MobileNavBotton/style";
import Select from "../Select";
import MobileSearch from "../MobileSearch";
import useViewport from "../../hooks/useView";
import { handleShowCart, handleTogglePoppup } from "../../redux/actions";
import useLocalStorageState from "../../hooks/useLocalStorageState";
import useQuery from "../../hooks/useQuery";
import BadgeCounter from "../../components/BadgeCounter";
import AlertLocalizationPopup from "../../components/AlertLocalizationPopup";
import LocalizationModal from "../../components/LocalizationModal";
import CityChangedSuccessfully from "../CityChanged";
import { CustomIcon } from "../CustomIcon";
import "./style.css";
import config from "../../config/enviroment";
import "external-svg-loader";
import { language } from "../../utils/language";
import { captureCartReturnPath } from "../../utils/cartReturnPath";

type TypesProps = {
	color: string;
	catalogueName: string;
	categories: any[];
	defaultLanguage: string;
	onLanguageChange: (language: string) => void;
};

const Header: FunctionComponent<TypesProps> = ({
	color,
	catalogueName,
	categories,
	defaultLanguage,
	onLanguageChange,
}) => {
	const { display, width } = useViewport();
	const location = useLocation();
	const history = useHistory();
	const query = useQuery();
	const [persist, setPersist] = useLocalStorageState("searchHistory", []);
	const [searchFoused, setSearchFocused] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [categorySelected, setCategorySelected] = useState("All");
	const [showSearchMobile, setShowSearchMobile] = useState(false);
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const shoppingCartState: ShoppingCartStateType = useSelector(
		(state: RootState) => state.shoppingCart
	);
	const displayRouteState: any = useSelector(
		(state: RootState) => state.displayRoute
	);
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const match: any = useRouteMatch("/vende/:idCatalog");
	const dispatch = useDispatch();
	const basePath = `/vende/${match?.params.idCatalog}`;
	const includePaths = [`${basePath}/`, `${basePath}`];
	const [pageSelected, setPageSelected] = useState({
		categories: false,
		home: false,
		shoppingcart: false,
	});
	const [valueSearch, setValueSearch] = useState(() => {
		let value = query.has("q") ? query.get("q") : "";
		return value ? value.toString() : "";
	});
	const [messageSearch, setMessageSearch] = useState(false);

	const handleCategoriesRedirect = () => {
		history.push(`${basePath}/categories`);
	};

	const handleHomeRedirect = () => {
		history.push(`${basePath}/`);
	};

	const handleBackButton = () => {
		setValueSearch("");
		history.goBack();
	};

	const handleOnSelectCategory = (item: string) => {
		setCategorySelected(item);
	};

	const handleOnFocusSearch = () => {
		setMessageSearch(false);
		setSearchFocused(true);
	};

	const handleOnBlurSearch = () => {
		setMessageSearch(false);
		setSearchFocused(false);
	};

	const handleSearchSubmit = (event: React.SyntheticEvent) => {
		event.preventDefault();
		const target = event.target as typeof event.target & {
			searchEpayco: { value: string };
		};
		const search = target.searchEpayco.value.toLowerCase();
		if (search === "") {
			setMessageSearch(true);
		} else {
			setValueSearch(search);
			handleSearch(search);
		}
	};

	const handleCleanSearch = () => {
		setMessageSearch(false);
		setValueSearch("");
	};

	const handleSearch = (search: string) => {
		setValueSearch(search);
		if (showSearchMobile) setShowSearchMobile(false);
		saveSearch(search);
		history.push(
			`${basePath}/search?q=${search}&category=${categorySelected}&page=1`
		);
	};

	const handleOnSearchMobile = () => {
		setShowSearchMobile((prev) => !prev);
	};

	const getHeaderTitle = () => {
		if (query.has("q") && valueSearch !== "") return query.get("q");
		else if (query.has("q") && valueSearch === "") return "";

		return displayRouteState.routeName;
	};

	const saveSearch = (queryToSave: string) => {
		const historySaved = persist.filter((val: string) => {
			return queryToSave.toLowerCase().localeCompare(val.toLowerCase());
		});
		setPersist([queryToSave, ...historySaved].slice(0, 5));
	};

	const handleChangeSearch = (value: string) => {
		setMessageSearch(false);
		setValueSearch(value.toLowerCase());
	};

	useEffect(() => {
		let newPageSelected = {
			categories: false,
			home: false,
			shoppingcart: false,
		};

		if (location.pathname === `${basePath}/categories`) {
			newPageSelected.categories = true;
		} else if (location.pathname === `${basePath}/`) {
			newPageSelected.home = true;
		} else if (location.pathname === `${basePath}/carrito/`) {
			newPageSelected.shoppingcart = true;
		}
		setPageSelected(newPageSelected);
		setMessageSearch(false);
		if (homeState.epaycoDeliveryProvider && !elogisticaState.showPoppup) {
			setTimeout(() => {
				openTooltip();
			}, 2500);
			dispatch(handleTogglePoppup());
		}
	}, [location]);

	const ref: any = useRef();
	const ref2: any = useRef();
	const ref3: any = useRef();
	const modalRef: any = useRef();

	const openTooltip = () => {
		if (width > 993 && ref.current) {
			ref.current.open();
		} else if (includePaths.includes(location.pathname) && ref3.current) {
			ref3.current.open();
		} else if (ref2.current) {
			ref2.current.open();
		}
	};

	const handleCalcProducts = () => {
		let contador = 0;

		shoppingCartState.cartInfo.map((item: any) => {
			if (item.references && item.references.length > 0) {

				item.references.map((ref:any)=>{
					contador += ref.quantity;

				});
			} else {
				contador+=item.quantity;
			}
		});
		return contador;
	};

	interface LanguageButtonsProps {
		currentLanguage: string;
		onLanguageChange: (language: string) => void;
	}

	const LanguageButtons: React.FC<LanguageButtonsProps> = ({
		currentLanguage,
		onLanguageChange,
	}) => (
		<div className="header__language-buttons__container">
			<button
				onClick={() => onLanguageChange("ESP")}
				className={currentLanguage === "ESP" ? "active-language" : "not-active"}
			>
				ES
			</button>
			<span>/</span>
			<button
				onClick={() => onLanguageChange("ENG")}
				className={currentLanguage === "ENG" ? "active-language" : "not-active"}
			>
				EN
			</button>
		</div>
	);

	return (
		<>
			<MobileSearch
				color={homeState.color}
				show={showSearchMobile}
				onClose={handleOnSearchMobile}
				onSearch={(event: React.SyntheticEvent | string) => {
					if (typeof event === "string") handleSearch(event);
					else handleSearchSubmit(event);
				}}
				history={persist}
				searchValue={valueSearch}
				handleChangeSearch={handleChangeSearch}
			/>
			<HeaderContainer>
				{includePaths.includes(location.pathname) || display === "desktop" ? (
					<>
						<Nav>
							<HeaderImgContainer>
								<HeaderImg src={homeState.image} onClick={handleHomeRedirect} />
							</HeaderImgContainer>

							<div>
								<Search
									onSubmit={handleSearchSubmit}
									isFoused={searchFoused}
									color={color}
								>
									<InputContainer>
										<InputOnly
											type="text"
											value={valueSearch}
											onFocus={handleOnFocusSearch}
											onBlur={handleOnBlurSearch}
											name="searchEpayco"
											onChange={(e) => handleChangeSearch(e.target.value)}
											color={color}
											placeholder={
												language[homeState.default_language][
													"searchPlaceholder"
												]
											}
										/>
										{valueSearch !== "" && (
											<Button
												color={"#fff"}
												name={"iconClear"}
												type="reset"
												onClick={handleCleanSearch}
											>
												<CleanSearchImg>
													<svg
														data-src={`${config.urlMultimedia}/vende/landing-img/close.svg`}
													/>
												</CleanSearchImg>
											</Button>
										)}
									</InputContainer>
									<Select
										items={categories}
										onSelect={handleOnSelectCategory}
									/>
									<Button color={color} type="submit">
										<img
											alt=""
											src={`${config.urlMultimedia}/vende/landing-img/lupa.png`}
										/>
									</Button>
								</Search>
								{messageSearch && <MessageSearch>{}</MessageSearch>}
							</div>

							<Ul>
								<Li
									color={color}
									isSelected={pageSelected.home}
									onClick={handleHomeRedirect}
								>
									{language[homeState.default_language]["home"]}
								</Li>

								<Li
									color={color}
									isSelected={pageSelected.categories}
									onClick={handleCategoriesRedirect}
								>
									{language[homeState.default_language]["category"]}
								</Li>

								<Li
									color={color}
									isSelected={pageSelected.categories}
									onClick={handleCategoriesRedirect}
								></Li>
							</Ul>

							{homeState.epaycoDeliveryProvider && display === "desktop" && (
								<ButtonGeo color={color}>
									<CityChangedSuccessfully color={color}>
										<CustomIcon
											color={color}
											hover={false}
											type="localization"
										/>
										<AlertLocalizationPopup
											refData={ref}
											mode="desktop"
											color={color}
											showModalLocalization={() => {
												setOpenModal(true);
												modalRef.current.open();
											}}
										/>
									</CityChangedSuccessfully>
								</ButtonGeo>
							)}

							<HeaderButtonsContainer color={color}>
								<ButtonShopMobile onClick={handleOnSearchMobile}>
									<img
										alt=""
										src={`${config.urlMultimedia}/vende/landing-img/whitelupa.png`}
									/>
								</ButtonShopMobile>
								<LanguageButtons
									currentLanguage={defaultLanguage}
									onLanguageChange={onLanguageChange}
								/>

								<ButtonShop
									color={color}
									onClick={() => dispatch(handleShowCart())}
								>
									<img
										alt="shop"
										src={`${config.urlMultimedia}/vende/landing-img/CartIconLight.svg`}
									/>
									{shoppingCartState.cartInfo.length > 0 && (
										<BadgeCounter
											color={homeState.color}
											totalCartProducts={handleCalcProducts()}
										/>
										
										
									)}
								</ButtonShop>
								{homeState.epaycoDeliveryProvider && width < 993 && (
									<MobileLocalization>
										<AlertLocalizationPopup
											refData={ref3}
											mode="mobile"
											color={color}
											showModalLocalization={() => {
												setOpenModal(true);
												modalRef.current.open();
											}}
										/>
									</MobileLocalization>
								)}
							</HeaderButtonsContainer>
						</Nav>
					</>
				) : (
					<>
						<NavMobile
							color={homeState.color}
							epaycoDelivery={homeState.epaycoDeliveryProvider}
						>
							<HeaderImagePrint>
								<HeaderImg src={homeState.image} />
							</HeaderImagePrint>

							{includePaths.includes(location.pathname) ||
							match?.params.idCatalog === undefined ? (
								<HeaderImgMovilContainer>
									<HeaderImgMovil
										src={homeState.image}
										onClick={handleHomeRedirect}
									/>
								</HeaderImgMovilContainer>
							) : (
								<MobileIconContainer onClick={handleBackButton}>
									<svg
										data-src={`${config.urlMultimedia}/vende/landing-img/arrowLeft.svg`}
									/>
								</MobileIconContainer>
							)}

							<MobileHeaderTitleContainer>
								<MobileHeaderTitle>
									{includePaths.includes(location.pathname) ||
									match?.params.idCatalog === undefined
										? ""
										: getHeaderTitle()}
								</MobileHeaderTitle>
							</MobileHeaderTitleContainer>
							<MobileIconContainer>
								{valueSearch !== "" && (
									<CleanSearchImg onClick={handleCleanSearch}>
										<svg
											data-src={`${config.urlMultimedia}/vende/landing-img/close.svg`}
										/>
									</CleanSearchImg>
								)}
								<svg
									data-src={`${config.urlMultimedia}/vende/landing-img/Lens.svg`}
									onClick={handleOnSearchMobile}
								/>
							</MobileIconContainer>
							{homeState.epaycoDeliveryProvider && (
								<MobileLocalization>
									<CityChangedSuccessfully color={color}>
										<AlertLocalizationPopup
											refData={ref2}
											mode="mobile"
											color={color}
											showModalLocalization={() => {
												setOpenModal(true);
												modalRef.current.open();
											}}
										/>
									</CityChangedSuccessfully>
								</MobileLocalization>
							)}
							<HeaderButtonsContainer color={color}>
								<LanguageButtons
									currentLanguage={defaultLanguage}
									onLanguageChange={onLanguageChange}
								/>
							</HeaderButtonsContainer>
							<MobileIconContainer>
								<StyledMobileMenuICons
									onClick={() =>
										history.push(
											shoppingCartState.cartInfo.length > 0
												? `${basePath}/carrito/${shoppingCartState.id}`
												: `${basePath}/carrito/empty`,
											{ from: captureCartReturnPath() }
										)
									}
									color={homeState.color}
									isSelected={pageSelected.shoppingcart}
								>
									<svg
										data-src={`${config.urlMultimedia}/vende/landing-img/ShoppingCart.svg`}
									/>
									{shoppingCartState.cartInfo.length > 0 && (
										<BadgeCounter
											color={homeState.color}
											totalCartProducts={handleCalcProducts()}
											isSelected={pageSelected.shoppingcart}
										/>
									)}
								</StyledMobileMenuICons>
							</MobileIconContainer>
						</NavMobile>
					</>
				)}
			</HeaderContainer>
			{/* <LocalizationModal
				color={color}
				refData={modalRef}
				openModal={openModal}
			/> */}
		</>
	);
};

export default Header;
